import { useLazyQuery } from '@apollo/client';

import { GET_MULTI_ITEM_RECOMMENDATION } from '../../mocks/queries';

/**
 * Returns a list of recommended products by product ID sent in productsData
 * @param {*} productsData: ArrayOf<{id, limit}>
 */
const useMultiItemRecommendations = () => {
  const [getMultiRecommendedProducts, { data, loading }] = useLazyQuery(
    GET_MULTI_ITEM_RECOMMENDATION
  );

  return {
    getMultiRecommendedProducts,
    data,
    loading,
  };
};

export default useMultiItemRecommendations;
